import { render, staticRenderFns } from "./CompleteRegistrationForm.vue?vue&type=template&id=2ee95bbf&scoped=true&"
import script from "./CompleteRegistrationForm.vue?vue&type=script&lang=js&"
export * from "./CompleteRegistrationForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ee95bbf",
  null
  
)

export default component.exports